import { Route, Routes } from 'react-router-dom';
import DynamicFlow from './DynamicFlow.tsx';
import CreateMap from './Create.tsx';
import TestCreatorPage from '../Test/TestCreatorPage.tsx';
import DoubtAssistantPage from '../Test/ConceptBuilder/DoubtAssistantPage.tsx';
import PerformanceMap from '../Test/PerformanceMap.tsx';
import StudentPerformanceMap from './StudentPerformanceMap.tsx';
import StudentDashboard from '../Test/StudentDashboard.tsx';
import QuestionBankGenerator from '../Test/QuestionGenrate/Questionbankgenerator.tsx';
import CompleteTeacherDashboard from '../Test/CompleteTeacherDashboard.tsx';
// import QuestionBankGenerator from '../Test/QuestionBankGenerator.tsx';

const Performance = () => {
  return (
    <Routes>
      <Route path={`/knowledge-map`} element={<DynamicFlow />} />
      <Route path={`/create`} element={<CreateMap />} />
      <Route path='/edit/:classId' element={<CreateMap />} />
      <Route path='/create-test' element={<TestCreatorPage />} />
      <Route path='/concept-builder' element={<DoubtAssistantPage />} />
      <Route path='/concept-builder/:conversationId/:phoneNumber' element={<DoubtAssistantPage />} />
      <Route path='/performance-map' element={<StudentPerformanceMap />} />
      <Route path='/notices' element={<StudentDashboard />} />
      {/* <Route path='/question-bank' element={<QuestionBankGenerator />} /> */}
      <Route path='/question-bank' element={<QuestionBankGenerator />} /> 
       <Route path='/teacher' element={<CompleteTeacherDashboard />} /> 
    </Routes>
  );
};
export default Performance;
